import { format } from "date-fns";

import CategoryRow from "./CategoryRow";
import RoomRow from "./RoomRow";

const fmtDate = "yyyy-MM-dd";

function CalendarBody({ rooms, rack, dates, prices, handleOpenFolio }) {
  const initialDate = format(dates[0], fmtDate);
  const rows = [];
  for (const [roomAccoId, grouped] of rooms) {
    rows.push(
      <CategoryRow
        idx={grouped.accoId}
        key={grouped.accoName}
        data={grouped}
        dates={dates}
        prices={prices}
      />,
    );
    for (const [roomId, room] of grouped.rooms.entries()) {
      let foliosByRoom = rack.get(roomId);
      if (!foliosByRoom) {
        foliosByRoom = [];
      }
      rows.push(
        <RoomRow
          idx={room.id}
          key={room.id}
          room={room}
          data={foliosByRoom}
          dates={dates}
          initialDate={initialDate}
          handleOpenFolio={handleOpenFolio}
        />,
      );
    }
  }

  return (
    <tbody className="overflow-hidden" key="table-body-rack">
      {rows}
    </tbody>
  );
}

export default CalendarBody;
